import { useEffect } from "react";

/**
 * Ant Design Drawer close can fail to run onClose when header layout/CSS blocks the
 * native button handler. This capture-phase listener closes on any mouseup/touchend
 * on `.welcome-reviews-drawer .ant-drawer-close` (icon or button).
 */
export function useWelcomeReviewsDrawerCloseEffect(drawerOpen, onClose) {
  useEffect(() => {
    if (!drawerOpen || typeof onClose !== "function") {
      return undefined;
    }

    const handlePointerUp = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      if (!target.closest(".welcome-reviews-drawer .ant-drawer-close")) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      onClose(event);
    };

    document.addEventListener("mouseup", handlePointerUp, true);
    document.addEventListener("touchend", handlePointerUp, true);
    return () => {
      document.removeEventListener("mouseup", handlePointerUp, true);
      document.removeEventListener("touchend", handlePointerUp, true);
    };
  }, [drawerOpen, onClose]);
}
